import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <section className="privacy-banner">
        <div className="privacy-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">PRIVACY POLICY</h2>
          </div>
        </div>
      </section>

      <section className="privacy-content">
        <div className="privacy-wrapper">
          <div className="privacy-text">
            <h2 className="content-title">Privacy Policy</h2>

            <p>
              Ampire Finance Private Limited (we, our, us) operates the <a href="https://www.fastpaise.com" target="_blank" rel="noopener noreferrer" className="email-link">https://www.fastpaise.com</a> website (the Service). This Privacy Policy explains how we collect, use, and share your personal information when you use our Service.
            </p>

            <h3 className="section-heading">Information We Collect</h3>

            <p>
              <strong>Personal Information:</strong> When you apply for a loan or use our Services, we may collect personal information such as your name, address, email address, phone number, date of birth, and other identifying information.
            </p>

            <p>
              <strong>Usage Information:</strong> We may collect information about how you access and use our website and services, including IP addresses, browser type, and operating system.
            </p>

            <p>
              <strong>Financial Information:</strong> Bank account details, credit card information, credit history, and other financial data necessary for providing our services.
            </p>

            <p>
              <strong>Identification Documents:</strong> Copies of government-issued identification documents, such as passports or driver's licenses.
            </p>

            <h3 className="section-heading">How We Use Your Information</h3>

            <p>We use your information for the following purposes:</p>
            <ul className="policy-list">
              <li>To provide and maintain our services.</li>
              <li>To process your transactions and manage your accounts.</li>
              <li>To verify your identity and prevent fraud.</li>
            </ul>

            <h3 className="section-heading">Data Security</h3>

            <p>
              We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure.
            </p>

            <h3 className="section-heading">Your Rights</h3>

            <p>Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>
            <ul className="policy-list">
              <li>The right to access your personal information.</li>
              <li>The right to correct any inaccurate or incomplete information.</li>
            </ul>

            <h3 className="section-heading">Data Retention and Deletion</h3>

            <p>
              You acknowledge that, in accordance with our document retention policy, Fast Paise may retain records for internal purposes.
            </p>

            <p>You have the right to:</p>
            <ul className="policy-list">
              <li>Consent to the use of certain data, limit disclosure to third parties, control data retention, or revoke consent that has already been given (where applicable) once your credit obligations are fully settled.</li>
              <li>Request deletion of your personal information.</li>
              <li>Exercise rights in line with applicable regulatory authority under the Prevention of Money-Laundering Act, 2002.</li>
            </ul>

            <h3 className="section-heading">Cookies and Tracking Technologies</h3>

            <p>
              We use cookies and similar tracking technologies to enhance your experience on our website. You can control the use of cookies through your browser settings.
            </p>

            <h3 className="section-heading">Grievance Officer</h3>

            <p>
              At Fast Paise, your privacy and satisfaction are our top priorities. To ensure your concerns are addressed promptly, we have appointed a dedicated Grievance Officer. If you have any issues regarding your personal information or our services, please don't hesitate to contact us.
            </p>

            <h3 className="section-heading">Contact Us</h3>

            <p>
              <strong>Phone:</strong> <a href="tel:+919650441767" className="email-link">+91 9650441767</a><br />
              <strong>Email:</strong> <a href="mailto:care@fastpaise.com" className="email-link">care@fastpaise.com</a><br />
              <strong>Address:</strong> 276, First Floor, Gagan Vihar, Shahdara, Delhi 110051
            </p>

            <h3 className="section-heading">Changes to This Privacy Policy</h3>

            <p>
              We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the updated Privacy Policy on our website.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
